import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../common/common_components/pagination_holder/Pagination_Holder";

const Table = ({ setEdit }) => {
  const data = [
    {
      srNo: "01",
      date: "01 Jan 2025",
      roleName: "Lab In-Charge",
      roleDescription:
        "Oversees overall laboratory operations, ensures workflow efficiency, & manages daily lab activities.",
      status: "Active",
    },
    {
      srNo: "02",
      date: "02 Jan 2025",
      roleName: "Lab Manager",
      roleDescription:
        "Manages lab staff, schedules, resources, and ensures compliance with procedures and testing requirements.",
      status: "Inactive",
    },
    {
      srNo: "03",
      date: "03 Jan 2025",
      roleName: "Lab Technician",
      roleDescription:
        "Performs testing, sampling, and routine laboratory procedures following standard test methods.",
      status: "Active",
    },
    {
      srNo: "04",
      date: "04 Jan 2025",
      roleName: "Quality Manager",
      roleDescription:
        "Ensures the laboratory's quality system is implemented, maintained, and aligned with accreditation standards.",
      status: "Inactive",
    },
    {
      srNo: "05",
      date: "05 Jan 2025",
      roleName: "Accounts Role",
      roleDescription:
        "Handles billing, payment tracking, financial entries, and account-related reporting within the system.",
      status: "Active",
    },
    {
      srNo: "06",
      date: "06 Jan 2025",
      roleName: "Instrument Engineer",
      roleDescription:
        "Maintains, calibrates, and troubleshoots laboratory instruments to ensure accurate and reliable results.",
      status: "Active",
    },
  ];

   const getStatusClass = (status) => {
    switch (status) {
      case "Active":
        return "green";
      case "Inactive":
        return "red";
      default:
        return "";
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Date</th>
                <th>Role Name</th>
                <th>Role Description</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {data.map((row, index) => (
                <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                  <td>{row.srNo}</td>
                  <td>{row.date}</td>
                  <td>{row.roleName}</td>
                  <td>{row.roleDescription}</td>
                    <td className={`status ${getStatusClass(row.status)}`}>
                    {row.status}
                  </td>
                  <td>
                    <div
                      className="edit_icon_holder"
                      onClick={() => {
                        setEdit(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faPencil} className="edit_icon" />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Table;
